import { HEADER_OFFSET } from "config/config";
import usePaxSession from "features/shared/hooks/usePaxSession";
import Logging from "logging";
import { useEffect } from "react";
import { ProcessingError } from "store/slices/app-slice";
import { PassportFormErrors } from "store/slices/passport-slice";

import { passportFieldNameFromElementId } from "../utils/utils";

const useScrollToFirstIssue = (
  errors: PassportFormErrors,
  processingError: ProcessingError | null,
  formRef: React.RefObject<HTMLFormElement | null>
) => {
  const paxSession = usePaxSession();

  const errorKeys = Object.keys(errors) as Array<keyof PassportFormErrors>;
  // converting to string prevents comparing arrays by reference, which causes effect to be triggered on every render
  const errorKeysString = errorKeys.join(", ");

  useEffect(() => {
    // we want to scroll to first error only if there is no signals mismatch error
    if (processingError !== "signals_mismatch") {
      return;
    }

    if (!formRef.current) {
      Logging.log(
        "passport-form",
        paxSession?.paxSessionId || "missing",
        "formRef.current is null"
      );
      return;
    }

    const formChildrenArray = Array.prototype.slice.call(
      formRef.current.childNodes
    );
    const fieldsNamesInOrder = formChildrenArray.map((element) =>
      passportFieldNameFromElementId(element.id)
    );

    const firstErrorKey = fieldsNamesInOrder.find(
      (key) => errors[key] !== null
    );

    if (!firstErrorKey) {
      Logging.log(
        "passport-form",
        paxSession?.paxSessionId || "missing",
        "first error key is not found"
      );
      return;
    }

    const firstErrorElement = document.getElementById(
      `passport-field-${firstErrorKey}`
    );

    if (!firstErrorElement) {
      return;
    }

    const firstErrorTop = firstErrorElement.getBoundingClientRect().top;

    window.scrollTo({
      top: firstErrorTop - HEADER_OFFSET * 1.5,
      behavior: "smooth",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorKeysString, processingError]);
};

export default useScrollToFirstIssue;
